import { render, staticRenderFns } from "./InviteCandidate.vue?vue&type=template&id=62d2b71e"
import script from "./InviteCandidate.vue?vue&type=script&lang=js"
export * from "./InviteCandidate.vue?vue&type=script&lang=js"
import style0 from "./InviteCandidate.vue?vue&type=style&index=0&id=62d2b71e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports